var { name: acoThemeName } = Shopify.theme;
var acoThemeArray = [
  "dawn",
  "ride",
  "taste",
  "studio",
  "crave",
  "colorblock",
  "sense",
  "craft",
  "warehouse",
  "express",
  "minimal",
  "narrative",
  "supply",
  "debut",
  "simple",
  "brooklyn",
  "venture",
  "boundless",
  "impulse",
  "prestige",
  "expanse",
  "broadcast",
  "motion",
  "responsive",
  "focal",
  "ira",
  "empire",
  "editions",
  "alchemy",
  "fashionopolism",
  "boost",
  "symmetry",
  "icon",
  "envy",
  "blockshop",
  "venue",
  "streamline",
  "testament",
  "ecomsolid",
  "retina",
  "mabelchong",
  "woodmart",
  "debutify",
  "glossier",
  "kingdom",
  "turbo",
  "kalles",
  "refresh",
  "ella",
  "pacific",
  "shella",
  "masonry",
  "wokiee",
  "gecko",
  "flex",
  "electro",
  "flow",
  "modular",
  "coachksa",
  "konversion",
  "elessi",
  "shopbe",
  "showtime",
  "atlantic",
  "influence",
  "moltestore",
  "porto",
  "fastor",
  "district",
  "pipeline",
  "spark",
  "california",
  "forge",
  "expression",
  "shanghai",
  "mojave",
  "galleria",
  "evelix",
  "startup",
  "superstore",
  "zeexo",
  "habitat",
  "basel",
  "parallax",
  "booster-6.0.5",
  "avone os 2.0",
  "canopy",
  "story",
  "clevercomo",
  "lorenza",
  "muscle",
  "cospora",
  "freshio",
  "optimal",
  "7nine",
  "renoxa",
  "minimog - os 2.0",
  "meunt",
  "showcase",
  "xtra",
  "grid",
  "story thème",
  "booster premium",
  "maker",
  "emerge",
  "mera",
  "velatheme",
  "vela framework",
  "upscale",
  "baseline",
  "kvalifik",
  "bywud",
  "colors",
  "cocafe",
  "lusion",
  "legend",
  "woodstock fashionable",
  "chromium",
  "august",
  "bullet",
  "ziba update 2.0"
];

const acoThemeSetJSON = {
  superstore: {
    home: {
      parent: [".productgrid--item"],
      badge: [".productitem--image-link"],
      belowProductImage: [".productitem--image-link"],
      belowProductName: [".productitem--title"],
      belowProductPrice: [".productitem--price"],
    },
    collections: {
      parent: [".productgrid--item"],
      badge: [".productitem--image-link"],
      belowProductImage: [".productitem--image-link"],
      belowProductName: [".productitem--title"],
      belowProductPrice: [".productitem--price"],
      mutations: [".results--container"],
      mutationConfig: { "childList": true, "subtree": true },
    },
    products: {
      parent: [".product--container", ".productgrid--item"],
      badge: [".product-gallery--viewer", ".productitem--image-link"],
      belowProductImage: [".product--outer", ".productitem--image-link"],
      belowProductName: [".product-title", ".productitem--title"],
      belowProductPrice: [".product-pricing-container", ".productitem--price"],
      mutations: [".product-section--content", ".product-recommendations--section", ".site-main"],
      mutationConfig: { "childList": true, "subtree": true },
    },
    search: {
      parent: [".productgrid--item"],
      badge: [".productitem--image-link"],
      belowProductImage: [".productitem--image-link"],
      belowProductName: [".productitem--title"],
      belowProductPrice: [".productitem--price"],
    },
  }
};

var marginException = ["warehouse", "coachksa", "ella", "impulse"];

function getThemeName() {
  var themeName = "Dawn";
  if ((typeof window.BOOMR !== "undefined" || window.BOOMR.themeName !== "") && acoThemeArray.includes(window.BOOMR.themeName.toLowerCase())) {
    themeName = window.BOOMR.themeName;
  } else if (
    typeof Shopify !== "undefined" &&
    acoThemeArray.includes(Shopify.theme.name.toLowerCase())
  ) {
    themeName = Shopify.theme.name;
  } else {
    if (window.BOOMR.themeName === "" || themeName === undefined || !acoThemeArray.includes(window.BOOMR.themeName.toLowerCase())) themeName = window.BOOMR.themeId;
  }
  return themeName;
}


var acoShopName = "";
var acoShopJson = "";
var subscription = undefined;
var shopJSON = {};
var themeJSON = {};
/**
 * Given a CSS string, return an object with the CSS properties as keys and their values as values.
 * @param cssText - the CSS string
 * @returns The function returns an object with the CSS properties as keys and their values as values.
 */

function cssToObj(cssText) {
  var cssTxt = cssText.replace(/\/\*(.|\s)*?\*\//g, " ").replace(/\s+/g, " ");
  var style = {},
    [, , rule] = cssTxt.match(/ ?(.*?) ?{([^}]*)}/) || [, , cssTxt];
  var cssToJs = (s) =>
    s.replace(/\W+\w/g, (match) => match.slice(-1).toUpperCase());
  var properties = rule
    .split(";")
    .map((o) => o.split(":").map((x) => x && x.trim()));
  for (var [property, value] of properties) style[cssToJs(property)] = value;
  return style;
}
/**
 * Get the current page.
 * @returns The current page.
 */

const acoCurrentPage = getCurrentPage();
let converted = {};
/**
 * This function returns the URL of the labeler app.
 * @returns The function returns the URL of the labeler app.
 */
const labelerUrl = "https://cdn.labeler.apps.acowebs.com";
/**
 * A dictionary that stores values of added badges and label only once.
 * @param [value] - the value to store in the dictionary
 * @returns The function returns the value of the dictionary.
 */
var checked = {};
/**
 * Given a theme, return the product selectors for that theme.
 * @param theme - the theme to get the product selectors for
 * @returns The function returns an object containing the product selectors for the given theme.
 */
var productSelectors = [];
var productMutationSelectors = [];
var mutationConfig = {};
/**
 * Logs a value to the console if the debug property of the shopJSON object is true.
 * @param val - the value to log
 */

function logIt(val) {
  if (shopJSON.debug) {
    console.log(val);
  }
}
/**
 * Given a object of CSS styles, return a string of CSS styles.
 * @param style - a object of CSS styles
 * @returns The function returns a string of CSS styles.
 */

const convertToStyle = (style) => {
  return Object.keys(style).reduce(
    (acc, key) =>
      acc +
      key
        .split(/(?=[A-Z])/)
        .join("-")
        .toLowerCase() +
      ":" +
      style[key] +
      ";",
    ""
  );
};

var getPreviousSibling = function (elem, selector) {
  // Get the next sibling element
  var sibling = elem.previousElementSibling;
  // If there's no selector, return the first sibling
  if (!selector) return sibling;

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.previousElementSibling;
  }
};

/**
 * This function returns the current page.
 * @returns The function returns a string representing the current page.
 */

function getCurrentPage() {
  const path = window.location.pathname;
  if (path == "/") return "home";
  if (path.includes("search")) return "search";
  if (path.includes("products") && !path.includes("all-products")) return "products";
  if (path.includes("collections")) return "collections";
  if (path.includes("pages") && Shopify.shop.replace(".myshopify.com", "") === "petitegjewelers") return "home";
  if (path.includes("pages") && Shopify.shop.replace(".myshopify.com", "") === "firewoodoven") return "collections";
  if (path === "/en" && Shopify.shop.replace(".myshopify.com", "") === "rwroyalwatch") return "home";
  if ((path === "/en" || path === "/en/" || path === "/nl" || path === "/nl/" || path === "/de" || path === "/de/") && Shopify.shop.replace(".myshopify.com", "") === "rogier-miller") return "home";
}

function checkIfProductImage(url) {
  if(acoShopName === "xoxowildhearts") return true;
  return url.value.includes("products/");
}
/**
 * Given an element, return the product src.
 * @param element - the element to get the product src from
 * @returns The function returns the product src.
 */

function getProductSrcFromElement(element) {
  if (!element) return "";
  if (
    element.previousElementSibling &&
    element.previousElementSibling.nodeName === "SOURCE"
  ) {
    element = element.previousElementSibling;
  }
  var src = element.attributes["srcset"];
  if (!src || !checkIfProductImage(src)) src = element.attributes["src"];
  if (!src || !checkIfProductImage(src)) src = element.attributes["data-src"];
  if (!src || !checkIfProductImage(src))
    src = element.attributes["data-srcset"];
  if (!src || !checkIfProductImage(src))
    src = element.attributes["data-srcset"];
  if (!src || !checkIfProductImage(src))
    src = element.attributes["aria-label"];
  if (acoShopName === "80dafb" && acoCurrentPage !== "products" && (!src || !checkIfProductImage(src)))
    src = element.attributes["data-bgset"];
  if (acoShopName === "orange-you-chill-boutique" && (!src || !checkIfProductImage(src)))
    src = element.attributes["data-lazy-src"];
  if (!src || !checkIfProductImage(src) || src.value === "") return "";

  var url = src.value.replace("_{width}x", "").split(",")[0];
  if (acoShopName === "carmarthencameras" && acoCurrentPage === "products")
    url = src.value.replace("_{width}x", "").split(",")[1] || src.value.replace("_{width}x", "").split(",")[0];

  if (!url.includes("products/") && acoShopName !== "xoxowildhearts") return "";
  if (!/^https?:\/\//i.test(url)) {
    url = "https:" + url.replace(/\s/g, "");
  }


  var pathname;
  if (acoShopName === 'keissy-sousa-01b7' || acoShopName === 'labeler-product-labels') {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1");
  } else if (acoShopName === "macho-cave") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1").replace(/(?=_\d{2,3}x).*/g, "").replace(/_.*x/, '')
  } else if (acoShopName === "dgrendel") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1").replace(/(?=_\d+[Xx]\d).*/g, "")
  } else if (acoShopName === "innsport-ba" || acoShopName === "rare-fabric-childrens-boutique") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/^(.*)(_\d{2,3}x)$/, "$1");
  } else if (acoShopName === "hartford-marathon-foundation" || acoShopName === "6fd8f9") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/^(.*)(_\d{2,3}x)$/, "$1").replace('_large', '');
  } else if (acoShopName === "all-day-aesthetics-supplies") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/^(.*)(_\d{2,4}x)$/, "$1").replace('_300x300', '');
  } else if (acoShopName === "nirmini" || acoShopName === "central-vitamins") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/^(.*)(_\d{2,4}x)$/, "$1").replace('_small', '');
  } else if (acoShopName === "the-babycloset" || acoShopName === "offnova") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/^(.*)(_\d{2,4}x\d{2,4})$/, "$1");
  } else if (acoShopName === "the-little-house-of-fragrance") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/(?=_\d{2,4}x).*/g, "")
  } else if (acoShopName === "firewoodoven" || acoShopName === "e-gwc") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/^(.*)(_\d{2,4}x)$/, "$1")
      .replace(/^(.*)(_x\d{2,4}@2x)$/, "$1");
  } else if (acoShopName === "xhdata-cn") {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/^(.*)(_\d{2,4}x)$/, "$1")
      .replace(/^(.*)(_x\d{2,4})/, "$1")
      .replace('_large', '');
  } else {
    pathname = new URL(url).pathname
      .replace(/^(.+?)(?:\.[^.]*)?$/, "$1")
      .replace(/^(.*)(_\d{2,4}x)$/, "$1")
      .replace(/^(.*)(_\d{2,4}x\d{2,4})$/, "$1")
      .replace(/^(.*)(_\d{2,4}x@\d{1,4}x)$/, "$1")
      .replace(/^(.*)(_\d{2,4}x\d{2,4}@2x)$/, "$1")
      .replace(/^(.*)(_\d{2,4}x.progressive)$/, "$1");
  }

  const index = pathname.lastIndexOf("/");
  return -1 !== index ? pathname.substring(index + 1) : pathname;
}
/**
 * Given an element, a data source, a badge, and a type, insert the badge and its labels into the element.
 * @param element - the element to insert the badge into
 * @param dataSrc - the data source of the badge
 * @param convertedBadge - the badge to insert
 * @param type - the type of badge to insert
 */

function insertBadgeAndLabels(element, dataSrc, convertedBadge) {
  const { imagePath, styleUpdated, schedule, dynamic } = convertedBadge;
  if (schedule?.status && (subscription || subscription === undefined)) {
    if (moment(moment.utc().format()).isBefore(schedule.start)) return;
    if (moment(moment.utc().format()).isAfter(schedule.end)) return;
    if (scheduleTime(schedule)) return;
  }

  if (!element) return;
  const id = `aco-badge-${dataSrc}-${convertedBadge.id}`; //     if (checked[id]) { //         logIt("already checked"); //     } else { //         logIt(type); //         checked[id] = true;
  if (element.parentElement.querySelector(`.product-badge_aco[id='${id}']`) || element.parentElement.querySelector(`.product-badge_aco_img[id='${id}']`))
    return null;
  if (convertedBadge.type === "badge") {
    insertBadge(element, imagePath, styleUpdated, id, dynamic, dataSrc, convertedBadge);
  } else {
    insertLabel(element, imagePath, styleUpdated, id, dynamic, dataSrc, convertedBadge);
  } //     }
  logIt(checked);
}

function removeInherits(margin) {
  const clone = cssToObj(margin);
  Object.keys(clone).forEach((key) => {
    if (clone[key] === "inherit") delete clone[key];
    else clone[key] = `${clone[key]} !important`
  });
  return clone;
}

/**
* Given an element, return the height of the element.
* @param element - the element to get the height of
* @returns The function returns the height of the element.
*/
function getElementHeight(element) {
  var divHeight = 0;
  if (element.offsetHeight) {
    divHeight = element.offsetHeight;
  } else if (element.style.pixelHeight) {
    divHeight = element.style.pixelHeight;
  } else if (element.clientHeight) {
    divHeight = element.clientHeight;
  }
  return divHeight;
}

/**
* scheduling badges for a specific time period based on user given timezone
* @params given scheduled dates and time
*/
const scheduleTime = (schedule) => {
  let timeZone = schedule?.timezone.split(' ');
  let day = new Date().toLocaleString("en-US", { weekday: 'long', timeZone: timeZone[timeZone.length - 1] });
  let currentDay = schedule?.weekdays[day.toLocaleLowerCase()];
  let month = new Date().toLocaleString("en-US", { dateStyle: "short", timeZone: timeZone[timeZone.length - 1] })
  if (!currentDay.status) return true;
  const startDate = moment.utc(`${month} ${currentDay.start}`).format();
  const endDate = moment.utc(`${month} ${currentDay.end}`).format();
  const zone = timeZone[timeZone.length - 1];
  if (moment(moment.utc().format()).isBefore(moment.tz(startDate.replace('Z', ''), zone).utc().format())) return true;
  if (moment(moment.utc().format()).isAfter(moment.tz(endDate.replace('Z', ''), zone).utc().format())) return true;
  return false;
}

/**
 * Given an element, an image path, a style object, and an id, insert the badge into the element.
 * @param element - the element to insert the badge into
 * @param imagePath - the path to the badge
 * @param styleUpdated - the style object to apply to the badge
 * @param id - the id of the badge
 * @param dynamic - the dynamic configuration of the label
 * @param dataSrc - the data src of the product
 * @param convertedBadge - the badge to insert
 */

function insertBadge(element, imagePath, styleUpdated, id, dynamic, dataSrc, convertedBadge) {
  try {
    const themeSelector = themeJSON[acoCurrentPage];
    const margins = removeInherits(styleUpdated.margin);
    const positionClass = cssToObj(
      styleUpdated.margin
    ).objectPosition.replace(" ", "-");
    const width = styleUpdated.width;
    const height = styleUpdated?.aspectRatio ? "auto" : styleUpdated.height;
    let parentClass = `product-badge_aco ${positionClass} `;
    if (styleUpdated?.aspectRatio) parentClass += " aspect-ratio-enabled ";
    else parentClass += " aspect-ratio-disabled ";
    if (styleUpdated?.width.includes("px")) parentClass += " pixelified ";
    else parentClass += " percentified ";
    const childClass = `product-badge_aco_img aco_badge animate__${styleUpdated?.animation?.name} img_${positionClass}`;

    var childStyle = {
      zIndex: 2,
      visibility: "visible",
      opacity: styleUpdated?.opacity || 1,
      width: "100%",
      height: "100%",
      margin: 0,
      position: "relative",
      objectFit: "fill",
      background: "transparent",
      maxWidth: "100%",
      maxHeight: "100%",
      animationDuration: `${styleUpdated?.animation?.duration}s !important`,
      animationIterationCount: `${styleUpdated?.animation?.iteration} !important`,
      animationName: `${styleUpdated?.animation?.name} !important`,
    };

    const parentStyle = {
      width,
      height,
      position: "absolute",
      ...margins,
      transform: `rotate(${styleUpdated?.angle || 0}deg)`,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      overflow: "visible",
      zIndex: 2,
    };

    const marginTop = Math.max(
      Math.abs(parseInt(margins.top)) || 0,
      parseInt(element.style.marginTop) || 0
    );
    const marginBottom = Math.max(
      Math.abs(parseInt(margins.bottom) || 0),
      parseInt(element.style.marginBottom) || 0
    );

    if (Object.values(margins).filter((word) => word.startsWith("-"))) {
      if (typeof acoThemeName !== "number" && !marginException.includes(acoThemeName.toLowerCase())) {
        if (marginTop) element.closest(themeSelector.parent).style.marginTop = `${marginTop}px`
        if (marginBottom) element.closest(themeSelector.parent).style.marginBottom = `${marginBottom}px`
      }
      element.style.setProperty("overflow", "visible", "!important");
      element.style.setProperty(
        "position",
        element.style.position || "relative",
        "!important"
      );
    }

    let child = '';
    let parent = '';
    if (dynamic?.status) {
      fetch(labelerUrl + imagePath).then(response => response.text().then(svg => {
        parent = `<div id="${id}" class="${parentClass}" style="${convertToStyle(
          parentStyle
        )}">${svg}</div>`;

        if (
          element.querySelector(
            `.product-badge_aco_img.aco_badge.img_${positionClass}.aco_${dataSrc}_${convertedBadge.id}`
          )
        ) return null;

        element.classList.add("product-badge_aco_parent");
        element.insertAdjacentHTML("beforeend", parent);

        const selector = 'aco-badge-' + dataSrc + '-' + convertedBadge.id;
        element.querySelector('#' + selector + ' svg').classList.add(...childClass.split(' '), 'aco_' + dataSrc + '_' + convertedBadge.id);
        element.querySelector('#' + selector + ' svg').style = convertToStyle(childStyle);
        element.querySelectorAll('#' + selector + ' svg')[1].style = '';
        element.querySelector('#' + selector + ' svg #tchange tspan').innerHTML = convertedBadge.percentage + '%';
      }));
    } else {
      child = `<img class="${childClass}" src="${labelerUrl}${imagePath}" style="${convertToStyle(
        childStyle
      )}" alt="image" />`;
      parent = `<div id="${id}" class="${parentClass}" style="${convertToStyle(
        parentStyle
      )}">${child}</div>`;
      if (
        element.querySelector(
          `.product-badge_aco_img.aco_badge.img_${positionClass}[src="${labelerUrl}${imagePath}"]`
        )
      )
        return null;

      element.classList.add("product-badge_aco_parent");
      element.insertAdjacentHTML("beforeend", parent);
    }

    const extra = themeSelector?.extra?.badge;
    if (extra) extra(element, styleUpdated);
  } catch (error) {
    logIt(error);
  }
}
/**
 * Given a parent element and a theme selector, return the element that matches the theme selector that displays.
 * @param labelParent - the parent element
 * @param themeSelector - the theme selector
 * @returns The function returns the element that matches the theme selector.
 */

function findDisplayElement(labelParent, themeSelector, styleUpdated) {
  if (themeSelector[styleUpdated.position].join(",").includes("last-of-type"))
    return labelParent.querySelector(
      themeSelector[styleUpdated.position].join(",")
    );
  var allMatching = labelParent.querySelectorAll(
    themeSelector[styleUpdated.position].join(",")
  );
  return Array.from(allMatching).find(
    (el) => window.getComputedStyle(el).display !== "none"
  );
}

/**
 * Given an element, an image path, a style object, and an id, insert the label into the element.
 * @param element - the element to insert the label into
 * @param imagePath - the path to the label
 * @param styleUpdated - the style object to apply to the label
 * @param id - the id of the label
 * @param dynamic - the dynamic configuration of the label
 * @param dataSrc - the data src of the product
 * @param convertedBadge - the badge to insert
 */
function insertLabel(element, imagePath, styleUpdated, id, dynamic, dataSrc, convertedBadge) {
  try {
    const themeSelector = themeJSON[acoCurrentPage];
    const labelParent = element.closest(themeSelector.parent.join(","));
    const labelContainer = findDisplayElement(
      labelParent,
      themeSelector,
      styleUpdated
    );
    if (
      labelParent.querySelector(
        `.product-badge_aco.${styleUpdated.position} img.aco_label[src="${labelerUrl}${imagePath}"]`
      )
    )
      return null;
    let height = styleUpdated.height;
    if (
      typeof styleUpdated.aspectRatio !== "undefined" &&
      !styleUpdated.aspectRatio
    ) {
      const updatedHeight = styleUpdated?.height?.replace("%", "");
      height = `${(labelContainer.clientWidth * updatedHeight) / 100}px`;
    }
    logIt(labelContainer);
    let parentClass = `product-badge_aco ${styleUpdated.position}`;
    if (styleUpdated?.aspectRatio) parentClass += " aspect-ratio-enabled ";
    else parentClass += " aspect-ratio-disabled ";
    if (styleUpdated?.width.includes("px")) parentClass += " pixelified ";
    else parentClass += " percentified ";
    const childClass = `product-badge_aco_img aco_label animate__${styleUpdated?.animation?.name}`;

    var childStyle = {
      animationDuration: `${styleUpdated?.animation?.duration}s`,
      animationIterationCount: styleUpdated?.animation?.iteration,
      animationName: `${styleUpdated?.animation?.name} !important`,
      float: "left",
      ...styleUpdated?.margin,
      width: `100%`,
      height,
      opacity: 1,
      objectFit: "fill",
      display: "block !important",
      margin: 0,
      background: "transparent",
      maxWidth: "100%",
      maxHeight: "100%",
    };

    const parentStyle = {
      opacity: styleUpdated?.opacity || 1,
      transform: `rotate(${styleUpdated?.angle || 0}deg)`,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      zIndex: 1,
      position: "relative",
      width: styleUpdated?.width,
    };

    let child = '';
    let parent = '';
    if (dynamic?.status) {
      fetch(labelerUrl + imagePath).then(response => response.text().then(svg => {
        if (labelParent.querySelector(
          `.product-badge_aco_img.aco_label.aco_${convertedBadge.id}`)
        ) return null;
        parent = `<div id="${id}" class="${parentClass}" style="${convertToStyle(parentStyle)}">${svg}</div>`;
        labelContainer.insertAdjacentHTML("afterend", parent);

        const selector = 'aco-badge-' + dataSrc + '-' + convertedBadge.id;
        labelContainer.parentElement.querySelector('#' + selector + ' svg').classList.add(...childClass.split(' '), 'aco_' + convertedBadge.id);
        labelContainer.parentElement.querySelector('#' + selector + ' svg').style = convertToStyle(childStyle);
        labelContainer.parentElement.querySelectorAll('#' + selector + ' svg')[1].style = '';
        labelContainer.parentElement.querySelector('#' + selector + ' svg #tchange tspan').innerHTML = convertedBadge.percentage + '%';
      }));
    } else {
      child = `<img class="${childClass}" src="${labelerUrl}${imagePath}" style="${convertToStyle(childStyle)}" alt="image" />`;
      parent = `<div id="${id}" class="${parentClass}" style="${convertToStyle(parentStyle)}">${child}</div>`;
      labelContainer.insertAdjacentHTML("afterend", parent);
    }
    const extra = themeSelector?.extra?.label;
    if (extra) extra(labelContainer);
  } catch (error) {
    logIt(error);
  }
}
const productSrcSelector = {
  "80dafb": ['img[srcset]', ' img[src]', 'img[data-src]', 'img[data-srcset]', 'div.product-item__bg[aria-label]', 'div.hover[data-bgset]'],
  "orange-you-chill-boutique": ['img[data-lazy-src]', 'img[srcset]', 'img[src]', 'img[data-src]', 'img[data-srcset]', 'source[srcset]', 'source[data-src]', 'source[data-srcset]', 'div.product-item__bg[aria-label]'],
  "brutus-monroe": ['img[data-src]', 'img[data-srcset]', 'img[data-rimg][src]', 'source[srcset]', 'source[data-src]', 'source[data-srcset]', 'div.product-item__bg[aria-label]']
}

/**
 * This function sets up the normal badges for the page.
 * @param productSelectors - an array of selectors for the product images.
 */

function setUpNormalBadges() {
  productSelectors.forEach((productSelector) => {
    const productImages = Array.from(
      document.querySelectorAll(productSelector.trim())
    );
    logIt(productImages);
    productImages.forEach((element) => {
      let dataSrc;
      if (productSrcSelector[acoShopName]) {
        dataSrc = getProductSrcFromElement(
          element.querySelector(productSrcSelector[acoShopName])
        );
      } else {
        dataSrc = getProductSrcFromElement(
          element.querySelector(
            "img[srcset], img[src], img[data-src], img[data-srcset], source[srcset] , source[data-src], source[data-srcset], div.product-item__bg[aria-label]"
          )
        );
      }

      if (dataSrc && (converted[dataSrc] || converted["*"])) {
        if (converted[dataSrc]) {
          for (const convertedBadge of converted[dataSrc]) {
            insertBadgeAndLabels(element, dataSrc, convertedBadge);
          }
        }
        for (const convertedBadge of converted["*"]) {
          insertBadgeAndLabels(element, dataSrc, convertedBadge);
        }
      }
    });
  });
}
/**
 * This function sets up the event listener for the lazyloaded event.
 */

function setUpLazyBadges() {
  document.addEventListener("lazyloaded", function (e) {
    const dataSrc = getProductSrcFromElement(e.target);
    if (
      e.target.closest(productSelectors.join(",")) &&
      dataSrc &&
      (converted[dataSrc] || converted["*"])
    ) {
      if (converted[dataSrc]) {
        for (const convertedBadge of converted[dataSrc]) {
          insertBadgeAndLabels(
            e.target.closest(productSelectors.join(",")),
            dataSrc,
            convertedBadge
          );
        }
      }
      for (const convertedBadge of converted["*"]) {
        insertBadgeAndLabels(
          e.target.closest(productSelectors.join(",")),
          dataSrc,
          convertedBadge
        );
      }
    }
  });
}
/**
 * This function sets up the mutation observer that will be used to detect changes to the product mutation selectors.
 * @param {function} setUpNormalBadges - the function that will be called to set up the normal badges.
 */

function setUpMutationBadges() {
  if (!productMutationSelectors) return null;
  var targets = Array.from(
    document.querySelectorAll(productMutationSelectors.join(","))
  );

  if (targets.length > 0) {
    for (const target of targets) {
      // create an observer instance
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function () {
          setUpNormalBadges();
          const afterAllFunction = themeJSON[acoCurrentPage]?.extra?.afterAll;
          if (afterAllFunction) afterAllFunction();
        });
      }); // configuration of the observer:

      var config = mutationConfig; // pass in the target node, as well as the observer options

      observer.observe(target, config);
    }
  }
}
/**
 * This function sets up the labelers.
 * @param {Array} productSelectors - An array of CSS selectors for the product images.
 */

function setUpLabelers() {
  const badges = Object.keys(shopJSON)
    .filter((key) => key.startsWith("badgeLabel"))
    .map((key) => shopJSON[key])
    .filter(
      (badge) => badge.selectedPages.includes(acoCurrentPage) && badge.status
    );
  subscription = shopJSON?.subscription;
  for (const element of badges) {
    const { styleUpdated, products, imagePath, id, rule, type, schedule: scheduleJson, dynamic = {} } = element;
    const encodedImage = encodeURI(imagePath);
    let schedule = {};
    if (scheduleJson?.status) schedule = { ...scheduleJson };
    converted["*"] = converted["*"] || [];
    if (dynamic?.status) {
      for (const [key, value] of Object.entries(products)) {
        for (const product of value) {
          converted[product] = converted[product] || [];
          converted[product].push({ styleUpdated, imagePath: encodedImage, id, type, dynamic, percentage: key });
        }
      }
    } else {
      if (rule.key === "allProducts") {
        converted["*"].push({ styleUpdated, imagePath: encodedImage, id, type, schedule });
      } else {
        for (const product of products) {
          converted[product] = converted[product] || [];
          converted[product].push({ styleUpdated, imagePath: encodedImage, id, type, schedule });
        }
      }
    }
  }
  setUpNormalBadges();
  setUpLazyBadges();
  setUpMutationBadges();
  const afterAllFunction = themeJSON[acoCurrentPage]?.extra?.afterAll;
  if (afterAllFunction) afterAllFunction();
}

function scriptLoader(path, callback) {
  let script = document.createElement('script');
  script.type = "text/javascript";
  script.async = true;
  script.src = path;
  document.head.appendChild(script);
  script.onload = function () {
    if (typeof (callback) == "function") {
      callback();
    }
  }
}


async function loadFiles(shopJSON) {
  const schedule = Object.keys(shopJSON)
    .filter((key) => key.startsWith("badgeLabel"))
    .map((key) => shopJSON[key])
    .filter((badge) => badge?.schedule?.status && badge.status);
  if (schedule.length !== 0) {
    scriptLoader(`${labelerUrl}/extension/moment.min.js`, function () {
      scriptLoader(
        `${labelerUrl}/extension/moment-timezone-with-data.min.js`,
        function () {
          setUpLabelers();
        }
      );
    });
  } else {
    setUpLabelers();
  }
}

function loadScript() {
  acoThemeName = getThemeName();
  document.querySelector('body').setAttribute('aco-theme-name', acoThemeName);
  document.querySelector('body').setAttribute('aco-theme-locale', Shopify.locale);
  document.querySelector('body').setAttribute('aco-theme-page', acoCurrentPage);
  acoShopName = Shopify.shop.replace(".myshopify.com", "");
  document.querySelector('body').setAttribute('aco-shop-name', acoShopName);
  document.querySelector('body').setAttribute('aco-theme-version', BOOMR.themeVersion);
  acoShopJson = `${labelerUrl}/productJS/${acoShopName}.json`;
  if (typeof acoThemeName === "number") {
    themeJSON = acoThemeSetJSON[acoThemeName];
  } else {
    themeJSON = acoThemeSetJSON[acoThemeName.toLowerCase()];
  }
  productSelectors = themeJSON[acoCurrentPage].badge;
  productMutationSelectors = themeJSON[acoCurrentPage].mutations;
  mutationConfig = themeJSON[acoCurrentPage].mutationConfig || {
    childList: true,
  };
  fetch(acoShopJson)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      shopJSON = data;
      if (typeof shopJSON.status === "undefined" || shopJSON.status) {
        loadFiles(shopJSON);
        logIt(converted);
      }
    });
}

if (typeof window.BOOMR !== "undefined") {
  loadScript();
} else if (document.addEventListener) {
  document.addEventListener("onBoomerangLoaded", function () {
    loadScript();
  });
}
